import { RootPaths } from "@src/appV2/App/paths";

export const STREAK_TRACKER_PATH = `${RootPaths.APP_V2_HOME}/streakTracker`;
